export * from './bantGameReports.service';
import { BantGameReportsService } from './bantGameReports.service';
export * from './gameReports.service';
import { GameReportsService } from './gameReports.service';
export * from './groupReports.service';
import { GroupReportsService } from './groupReports.service';
export * from './papReports.service';
import { PapReportsService } from './papReports.service';
export * from './parentReports.service';
import { ParentReportsService } from './parentReports.service';
export * from './portfolioManagerReports.service';
import { PortfolioManagerReportsService } from './portfolioManagerReports.service';
export * from './portfolioTeacherReports.service';
import { PortfolioTeacherReportsService } from './portfolioTeacherReports.service';
export * from './profileCopyTokens.service';
import { ProfileCopyTokensService } from './profileCopyTokens.service';
export * from './profileQrCodes.service';
import { ProfileQrCodesService } from './profileQrCodes.service';
export * from './schema.service';
import { SchemaService } from './schema.service';
export * from './stemReports.service';
import { StemReportsService } from './stemReports.service';
export * from './teacherReports.service';
import { TeacherReportsService } from './teacherReports.service';
export * from './transitionReports.service';
import { TransitionReportsService } from './transitionReports.service';
export const APIS = [BantGameReportsService, GameReportsService, GroupReportsService, PapReportsService, ParentReportsService, PortfolioManagerReportsService, PortfolioTeacherReportsService, ProfileCopyTokensService, ProfileQrCodesService, SchemaService, StemReportsService, TeacherReportsService, TransitionReportsService];
